import request from './request'

// 查询乡镇信息及点位列表
export function getTownPointList (params) {
  return request.get('/largescreen/town/getTownPointList', params).then(res => res);
}